import React from 'react';
import Text from 'Components/Text';

export default ({boat, boatDetailsRequestInProcess}) => {
  if (boatDetailsRequestInProcess) {
    return (
      <section className='scene_section'>
        <div className='ect-spinner'>
          <figure className='ect-spinner__image' style={{width: 50, height: 50}} />
        </div>
      </section>
    );
  }

  if (!boat) return null;

  return (
    <section className='scene_section'>
      <header>Basic info</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Boat ID'
        removeUnderlines
        value={boat.id}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Boat Type'
        removeUnderlines
        value={boat.boatType}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Engine Type'
        removeUnderlines
        value={boat.engineType}
      />
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/BasicInfo.jsx